import type { ReactNode } from "react";

import { SidebarToggleButton } from "./SidebarToggleButton";

type PageViewHeaderProps = {
  title: string;
  badge?: ReactNode;
  actions?: ReactNode;
};

export function PageViewHeader({ title, badge, actions }: PageViewHeaderProps): React.JSX.Element {
  return (
    <div className="border-cyber-border flex-shrink-0 border-b py-2 pr-2 pl-0 md:px-4 md:py-3">
      <div className="flex flex-wrap items-center justify-between gap-2 px-2">
        <div className="flex min-w-0 items-center gap-2">
          <SidebarToggleButton />
          <h2 className="text-cyber-text truncate text-sm font-medium">{title}</h2>
          {badge}
        </div>

        {actions ? <div className="flex items-center gap-1.5 md:gap-2">{actions}</div> : null}
      </div>
    </div>
  );
}
